import { h, Fragment } from 'preact';

const SizeSelector = ({ option, optionId, productId, handleVariantChange, selectedOption, isQuickView }) => {
  if (optionId === 'product-option-Title') return null;
  const sortedOptions = option.values.sort((a, b) => {
    const aPrice = a[0] === '$' ? parseFloat(a.slice(1, -1)) : 0;
    const bPrice = b[0] === '$' ? parseFloat(b.slice(1, -1)) : 0;
    return aPrice - bPrice;
  });
  return (
    <div>
      <div className="flex flex-wrap mt-3 mb-3">
        <span htmlFor={optionId} className="block text-body-2 font-medium mr-[14px]">
          {option.name}
        </span>
        <div className="flex flex-wrap flex-1">
          {sortedOptions.map((value) => (
            <div key={`${optionId}-${value}`} className="flex items-center mr-[18px]">
              <label
                htmlFor={`${isQuickView ? 'qw' : ''}${productId}-${value.replace(' ', '')}`}
                className={`relative cursor-pointer ${option.values.length > 1 ? 'pl-4' : ''}`}
              >
                {option.values.length > 1 && (
                  <>
                    <input
                      type="radio"
                      id={`${isQuickView ? 'qw' : ''}${productId}-${value.replace(' ', '')}`}
                      name={`${productId}-${option.name}`}
                      value={value}
                      checked={selectedOption?.value === value}
                      onChange={handleVariantChange}
                      data-option-name={option.name}
                      className="peer absolute opacity-0 cursor-pointer"
                    />
                    <span
                      className="absolute top-[2px] left-0 w-[19px] h-[19px] text-black border border-grey-2 bg-white rounded-full
             after:content-[''] after:absolute after:inline-block after:w-[11px] after:h-[11px] after:top-[8.5px] after:left-[3px] after:-translate-y-1/2 after:rounded-full peer-checked:after:bg-black "
                    ></span>
                  </>
                )}

                <span className={`block text-grey-7 ${option.values.length > 1 ? 'ml-2' : ''}`}>{value}</span>
              </label>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
export default SizeSelector;
